export default {
	userbaseServerBaseUrl: process.env.REACT_APP_USERBASE_SERVER_BASE_URL
};
